import {AfterViewInit, Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges} from "@angular/core";
import { Page } from "../../models/page.model";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'paging',
  templateUrl: "./paging.html",
  styleUrls: [
    'paging.scss'
  ]
})

export class PagingComponent implements OnInit {
  @Input('code') code;
  @Input('paging') paging: any;
  sub : any;
  constructor(
  ) {

  }
  ngOnInit() {
    this.setData();
  }
  setData() {
    this.paging = this.paging || new Page();
  }
  getData() {
    return this.paging || {};
  }
}
